import { collection, getDocs, query, Timestamp, where } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { docsWithId } from '../db';
import { trackedCollection } from './tracked';

// Admin issue tracker ("admin_issues"). Open issues are 'open' or 'in-progress'.
const issues = trackedCollection('admin_issues');

export const subscribeIssues = issues.subscribe;
export const updateIssue = issues.update;
export const deleteIssue = issues.remove;

export function createIssue(data) {
  return issues.create({ ...data, lastObserved: Timestamp.now() });
}

/** Record that an issue was seen again, optionally updating its fields. */
export function markIssueObserved(id, data = {}) {
  return issues.update(id, { ...data, lastObserved: Timestamp.now() });
}

/** The open or in-progress issue with exactly this title, or null. */
export async function findActiveIssueByTitle(title) {
  const matches = docsWithId(await getDocs(query(collection(db, 'admin_issues'), where('title', '==', title))));
  return matches.find((issue) => issue.status === 'open' || issue.status === 'in-progress') || null;
}
